import Loading from '../../../Common/Loading';
import { Indicators } from './Indicators';
import { HomelessIndicator } from './HomelessIndicator';
import { useHomelessChartsDataContext } from './hooks/useHomelessChartsDataContext';
import { PermanenceTime } from './PermanenceTime';
import { HomelessAndReltativesContact } from './HomelessAndReltativesContact';
import { HomlessCondiction } from './HomlessCondiction';

export const Charts = () => {
    const { isLoading, data } = useHomelessChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <HomelessIndicator />
                <Indicators />
            </div>
            <div className="charts-side-by-side-dashboards">
                <PermanenceTime />
                <HomelessAndReltativesContact />
            </div>
            <div className="w-100">
                <HomlessCondiction />
            </div>
        </>
    );
};
